/* T3BLOGG_OS — assets/global.js
   Thin shim that exposes a few helpers Dawn snippets call at the global scope.
   The real modules (cart, boot, desktop, syslog, product) are loaded
   separately from layout/theme.liquid.
*/
(function () {
  'use strict';
  // No-op constructors to keep any leftover Dawn web-component refs from blowing up.
  if (!window.customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {}
    window.customElements.define('quantity-input', QuantityInput);
  }
  // sysLog convenience
  window.sysLog = function (text, level) {
    document.dispatchEvent(new CustomEvent('syslog', { detail: { text, level } }));
  };

  // Price formatting that matches Liquid's `money_without_trailing_zeros`
  // with the shop's money format (currently "{{amount_with_comma_separator}} kr"
  // → "1.333 kr", "449,50 kr"), so JS-rendered prices look like Liquid ones.
  const SEPARATORS = {
    amount:                                  [',', '.'],
    amount_no_decimals:                      [',', '.'],
    amount_with_comma_separator:             ['.', ','],
    amount_no_decimals_with_comma_separator: ['.', ','],
    amount_with_space_separator:             [' ', ','],
    amount_no_decimals_with_space_separator: [' ', ','],
    amount_with_period_and_space_separator:  [' ', '.'],
    amount_with_apostrophe_separator:        ["'", '.']
  };
  window.T3Money = function (cents) {
    const format = (window.Shopify && window.Shopify.money_format) || '{{amount_with_comma_separator}} kr';
    cents = Math.round(Number(cents) || 0);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      const [thousands, decimal] = SEPARATORS[key] || SEPARATORS.amount;
      const noDecimals = key.indexOf('no_decimals') !== -1 || cents % 100 === 0;
      const [whole, frac] = (cents / 100).toFixed(noDecimals ? 0 : 2).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    });
  };
})();
